import _ from 'lodash';
import { useEffect, useRef } from 'react';

function useDeepCompareMemoize(value) {
  const ref = useRef([]);
  const signalRef = useRef(0);

  if (!_.isEqual(value, ref.current)) {
    ref.current = _.cloneDeep(value);;
    signalRef.current += 1;
  }

  return [signalRef.current];
}


export default function useDeepCompareEffect(cb, deps) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(cb, useDeepCompareMemoize(deps));
}